import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const includes = ['Oltre 200 ricette sane e veloci', 'Menù settimanali pronti', 'Liste della spesa organizzate', 'Opzioni adatte alla congelazione', 'Lista di sostituti degli ingredienti', 'BONUS 1: 50 Merende Pronte in 5 Minuti', 'BONUS 2: Bambini Schizzinosi', 'BONUS 3: Snack Senza Zuccheri Raffinati', 'BONUS 4: Il Freezer della Mamma Organizzata', 'BONUS 5: 365 Giorni di Ispirazione'];
  return <section id="pricing" className="bg-gray-50 py-16 px-4" data-id="element-129">
      <div className="max-w-3xl mx-auto" data-id="element-130">
        <div className="text-center mb-10" data-id="element-131">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1f2e10]" data-id="element-132">
            Accedi oggi a Merende Felici™:
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#1f2e10] rounded-3xl overflow-hidden shadow-2xl border-4 border-[#c4f000]" data-id="element-133">
          <div className="bg-[#c4f000] text-[#1f2e10] text-center py-2 font-bold text-sm uppercase tracking-widest" data-id="element-134">
            Offerta Speciale a Tempo Limitato
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-135">
            <h3 className="text-3xl font-black text-white mb-8" data-id="element-136">
              Merende Felici™ + 5 Bonus
            </h3>

            <div className="bg-white/5 rounded-2xl p-6 mb-8 text-left border border-white/10" data-id="element-137">
              <p className="text-white font-bold mb-4 border-b border-white/10 pb-2" data-id="element-138">
                Riepilogo di tutto ciò che riceverai:
              </p>
              <ul className="space-y-3" data-id="element-139">
                {includes.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-140">
                    <Check size={18} className="text-[#c4f000] mt-0.5 flex-shrink-0" data-id="element-141" />
                    <span className="text-gray-300 text-sm" data-id="element-142">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mb-8" data-id="element-143">
              <p className="text-gray-400 line-through text-lg mb-1" data-id="element-144">
                Valore reale: €47
              </p>
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-145">
                <span className="text-white text-xl" data-id="element-146">Solo</span>
                <span className="text-5xl md:text-6xl font-black text-[#c4f000]" data-id="element-147">
                  €19
                </span>
              </div>
              <p className="text-red-400 font-bold text-sm animate-pulse" data-id="element-148">
                ⚠️ OFFERTA A TEMPO LIMITATO
              </p>
            </div>

            <CTAButton href="https://merende-felici.impultienda.ar/checkout" className="w-full text-xl py-5 mb-6" data-id="element-149">
              VOGLIO ACCEDERE ORA!
            </CTAButton>

            <p className="text-gray-400 text-xs mb-6" data-id="element-150">
              Accesso immediato a vita. Pagamento 100% sicuro.
            </p>

            <div className="flex flex-wrap justify-center items-center gap-4 border-t border-white/10 pt-6" data-id="element-151">
              {/* Payment Icons Mockup */}
              <div className="bg-white px-3 py-1 rounded text-[#1f2e10] font-bold text-xs" data-id="element-152">
                VISA
              </div>
              <div className="bg-white px-3 py-1 rounded text-[#1f2e10] font-bold text-xs" data-id="element-153">
                MASTERCARD
              </div>
              <div className="bg-white px-3 py-1 rounded text-[#1f2e10] font-bold text-xs" data-id="element-154">
                AMEX
              </div>
              <div className="bg-white px-3 py-1 rounded text-[#1f2e10] font-bold text-xs" data-id="element-155">
                APPLE PAY
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}